/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'
import { of } from 'rxjs'

import map from 'lodash/map'

import { getProductGroups as getProductGroupsService } from '@smartcoop/services/apis/smartcoopApi/resources/productGroup'

const PRODUCT_GROUP_FIELDS = [
  'productGroupId', 'name', 'description', 'slug','crops', 'createdAt'
]

export function productGroupService(database) {
  async function createOrUpdate(productGroups = []) {
    await database.write(async () => {
      const promises = productGroups.map((productGroup) => async () => {
        const register = await database.get('productGroup')
          .query(Q.where('productGroupId', productGroup?.productGroupId || productGroup?.id))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        if(productGroup?.deletedAt) {
          return
        }
        await database.get('productGroup').create((item) => {
          PRODUCT_GROUP_FIELDS.forEach((field) => {
            if(
              field === 'crops'
            ) {
              item[field] = JSON.stringify(productGroup[field])
            }
            if(field === 'productGroupId') {
              item[field] = productGroup?.productGroupId || productGroup?.id
            } else {
              item[field] = productGroup[field]
            }
          })
        })
      })

      await Promise.all(promises.map((fn) => fn()))
    })
  }

  async function deleteProductGroupById(productGroupId) {
    await database.write(async () => {
      const register = await database.get('productGroup')
        .query(Q.where('productGroupId', productGroupId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('productGroup').query().destroyAllPermanently()
    })
  }

  async function findProductGroupById(productGroupId) {
    return database
      .get('productGroup')
      .query(Q.where('productGroupId', productGroupId))
      .fetchOne()
  }

  function observeProductGroups(productsLoading = false) {
    if(productsLoading) {
      return of([])
    }

    const productCollection = database.collections.get('productGroup')

    return productCollection.query().observe()
  }

  async function syncProductGroups(params) {
    const { data: { data: response } } = await getProductGroupsService(
      { ...params, limit: 999999 }
    )

    await createOrUpdate(response)
  }

  return {
    createOrUpdate,
    clearTable,
    deleteProductGroupById,
    findProductGroupById,
    observeProductGroups,
    syncProductGroups
  }
}